import { useEffect } from 'preact/hooks';
import { hideModal, showModal, useSessionStore } from '../global-state/session';
import { useSignInState } from '../global-state/user';
import TopNav from './top-nav';

export default function AuthenticatedPage({ children }: { children: any }) {
  const signInState = useSignInState();
  const currentModal = useSessionStore((s) => s.currentModal);

  useEffect(() => {
    if (signInState === 'signed-out' && !currentModal) {
      showModal('sign-in');
    }
    return () => {
      if (currentModal === 'sign-in') {
        hideModal();
      }
    };
  }, [signInState, currentModal]);

  return (
    <>
      <TopNav />
      {children}
    </>
  );
}
